import Select, { SingleValue } from "react-select";
import { useSnapshot } from "valtio";
import { clientDashboardEvents, StatusFilter } from "../clientDashboardEvents";

type Option = { label: string; value: StatusFilter };

// All first and default, so the dashboard loads showing what it always showed (MPN-1964 AC1).
// "All Statuses" rather than "All Campaigns": the Campaign selector's own default is "All
// Campaigns", and the two sit side by side once a user has drilled in.
//
// No Upcoming. PO dropped it in review: an upcoming campaign has no performance data, so the
// view is always empty. Upcoming campaigns stay in the All view, labeled with their start
// date by the Campaign selector (AC3).
export const OPTIONS: Option[] = [
    { label: "All Statuses", value: "ALL" },
    { label: "Live", value: "LIVE" },
    { label: "Ended", value: "ENDED" },
];

export default function CampaignStatusSelect() {
    const snap = useSnapshot(clientDashboardEvents);
    const selected = OPTIONS.find((o) => o.value === snap.status) ?? OPTIONS[0];

    return (
        <div className="dash-filter">
            <Select<Option, false>
                options={OPTIONS}
                value={selected}
                onChange={(opt: SingleValue<Option>) => {
                    if (opt) clientDashboardEvents.triggerStatusChanged(opt.value);
                }}
                menuPlacement="bottom"
                isClearable={false}
            />
        </div>
    );
}
